'use client';

import { ReactNode, forwardRef } from 'react';
import Link, { LinkProps } from 'next/link';
import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { prependLocaleToPath } from '@/utils/helpers/url';
import useLocale from '@/hooks/useLocale';

interface LocalizedLinkProps extends Omit<LinkProps, 'href'>, Omit<MuiLinkProps, 'href' | 'component'> {
	href: string;
	children: ReactNode;
	prefetch?: boolean;
}

const LocalizedLink = forwardRef<HTMLAnchorElement, LocalizedLinkProps>(function LocalizedLink(
	{ href, children, prefetch, ...props },
	ref,
) {
	const locale = useLocale();
	const localizedHref = prependLocaleToPath(href, locale);

	return (
		<MuiLink component={Link} href={localizedHref} prefetch={prefetch} ref={ref} {...props}>
			{children}
		</MuiLink>
	);
});

export default LocalizedLink;
